// extracted by mini-css-extract-plugin
var _1 = "GroupSchedule_column__gKKGS";
var _2 = "GroupSchedule_container__bAH-A";
var _3 = "GroupSchedule_head__IBI-w";
export { _1 as "column", _2 as "container", _3 as "head" }
